/* eslint-disable */
export const USER_URL = 'user'